import { render } from "./ClientValidateForm.vue?vue&type=template&id=258deb72"
import script from "./ClientValidateForm.vue?vue&type=script&lang=js"
export * from "./ClientValidateForm.vue?vue&type=script&lang=js"

import exportComponent from "G:\\Project\\vue_demo\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__